import React from 'react'
import AwsConfig from '../../Config/AwsConfig'

function CastTeUi(props) {
  const {
    inputdata,
    handlechangete,
    CastTeValue,
    castCharacterTeValue,
    handlechangecharacterte,
  } = props
  return (
    <div>
      <label>Cast_Te</label>
      {inputdata.Moviecastte.length >= 1 && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            border: '1px solid lightgray',
            borderRadius: '1rem',
          }}
          className='rounded'
        >
          {inputdata.Moviecastte.map((e, index) => (
            <div
              key={index}
              style={{
                marginBottom: '10px',
                border: '1px solid black',
                padding: '3px',
                borderRadius: '1rem',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
                minWidth: '100px',
                minHeight: '45px',
                // justifyContent: 'center',
              }}
            >
              <div style={{ marginRight: '10px' }}>
                {inputdata.Moviecast[index].isAnonymous ? (
                  ''
                ) : (
                  <img
                    style={{
                      width: '2rem',
                      height: '2rem',
                      borderRadius: '50%',
                      marginRight: '15px',
                    }}
                    src={AwsConfig.movieCdnUrl + inputdata.Moviecast[index].posterURL}
                    // alt={inputData[inputFieldEnglish][index].name_En}
                  />
                )}
                {inputdata.Moviecast[index].isAnonymous ? (
                  <span
                    style={{
                      color: 'white',
                      backgroundColor: 'gray',
                      fontSize: '8px',
                      position: 'absolute',
                      top: '0px',
                      right: '10px',
                    }}
                  >
                    Anonymous
                  </span>
                ) : (
                  ''
                )}
              </div>
              <div style={{ flexGrow: 1 }}>
                <span>{e}</span>
              </div>
            </div>
          ))}
        </div>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {' '}
        <input
          onChange={event => handlechangete(event.target.value)}
          className='form-control'
          value={CastTeValue}
        />
        <label>as</label>{' '}
        <input
          onChange={event => handlechangecharacterte(event.target.value)}
          className='form-control'
          value={castCharacterTeValue}
          style={{ width: '50%' }}
        />{' '}
      </div>
    </div>
  )
}

export default CastTeUi
